<template>
  <b-row>
    <ChartHistogram
      size="12"
      offset="0"
      title="Total Tested"
      chartType="totalTested"
    />
  </b-row>
</template>

<script>
import ChartHistogram from "../../../components/chart/chartHistogram";

export default {
  name: "TotalTested",
  components: {
    ChartHistogram
  }
};
</script>
